var _path, _path2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCloseBurger(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.2634 17.6777C16.8729 18.0682 16.2306 18.0591 15.829 17.6575L0.313035 2.14152C-0.0886437 1.73984 -0.097689 1.09763 0.292832 0.707107C0.683353 0.316586 1.32557 0.325631 1.72725 0.72731L17.2432 16.2433C17.6449 16.6449 17.6539 17.2871 17.2634 17.6777Z",
    fill: "#FCE36E"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.6777 0.707003C18.0682 1.09751 18.0591 1.73975 17.6575 2.14142L2.14152 17.6574C1.73984 18.059 1.09762 18.0681 0.707106 17.6776C0.316595 17.2871 0.325631 16.6448 0.727309 16.2431L16.2433 0.727206C16.6449 0.325537 17.2872 0.316491 17.6777 0.707003Z",
    fill: "#FCE36E"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloseBurger);
export default __webpack_public_path__ + "static/media/close_burger.cdf02225bcf2ee77d64fd68854a78dd1.svg";
export { ForwardRef as ReactComponent };